<template>
	<div>
		<!-- 동반인 선택 문항 -->
		<v-layout
			:class="$route.path.indexOf('COUNSELORPAGE') > -1 ? 'viewport-item-counselor' : 'viewport-item'"
			justify-center
			:id="'viewportItem_companion'"
			v-if="step1"
		>
			<div class="">
				<div :class="nowWidth > 320 ? 'item-style' : 'item-style4'">
					<p class="surveyName">1. 방문예약시 동반인을 입력해주세요.</p>
					<v-divider class="my-2"></v-divider>
					<v-radio-group v-model="$store.state.CompanionData" hideDetails class="mt-1" :row="$route.path.indexOf('COUNSELORPAGE') > -1">
						<div v-for="(option, i) in Companion" :key="i" class="mb-2">
							<v-layout>
								<v-radio
									:label="option.detailname"
									:value="option.detailcode"
									class="mt-2"
									:ripple="false"
									:color="$store.state.PointColor7"
								></v-radio>
							</v-layout>
						</div>
					</v-radio-group>
				</div>
			</div>
		</v-layout>

		<!-- inputbox 문항 -->
		<v-layout
			v-for="(item, i) in $store.state.reservedayInputBox.categories"
			:class="$route.path.indexOf('COUNSELORPAGE') > -1 ? 'viewport-item-counselor' : 'viewport-item'"
			:key="i"
			justify-center
			:id="'viewportItem' + i"
			v-show="step1 ? item.type !== 30 && item.type !== 31 : item.type === 30 || item.type === 31"
		>
			<div>
				<div v-if="item.tag === 'location'" :class="nowWidth > 320 ? 'item-style' : 'item-style4'">
					<p class="surveyName">{{ i + 2 }}. {{ item.contents }}</p>
					<pre class="visitexplain">{{ item.explain }}</pre>
					<v-divider class="my-2"></v-divider>
					<div class="mt-2">
						<select-box :sel="$store.state.searchsel_city1" @change="loc_firstSelect"></select-box>
					</div>
					<div>
						<select-box
							:sel="$store.state.searchsel_city2"
							:disabled="$store.state.searchsel_city2.disabled"
							@change="loc_twoSelect"
						></select-box>
					</div>
					<div>
						<select-box :sel="$store.state.searchsel_city3" :disabled="$store.state.searchsel_city3.disabled"></select-box>
					</div>
				</div>
				<div v-else-if="item.type == 10" :class="nowWidth > 320 ? 'item-style' : 'item-style4'">
					<p class="surveyName">{{ i + 2 }}. {{ item.contents }}</p>
					<pre class="visitexplain">{{ item.explain }}</pre>
					<v-divider class="my-2"></v-divider>
					<v-radio-group
						v-model="item.value"
						hideDetails
						class="mt-1"
						@change="setRadioValue(i)"
						:row="$route.path.indexOf('COUNSELORPAGE') > -1"
					>
						<div v-for="(option, i) in item.category_details" :key="i" class="mb-2">
							<v-layout>
								<v-radio
									:label="option.detailname"
									:value="option.detailcode"
									class="mt-2"
									:ripple="false"
									:color="$store.state.PointColor7"
								></v-radio>

								<div v-if="option.detailname === '기타' && $store.state.nowRadioValue.indexOf(option.detailcode) !== -1" class="pl-3">
									<txtField v-model="item.etc" :txtField="item.items" class="mb-1 focusColor" />
								</div>
							</v-layout>
						</div>
					</v-radio-group>
				</div>
				<div v-else-if="item.type == 11" class="item-style">
					<p class="surveyName">{{ i + 2 }}. {{ item.contents }}</p>
					<pre class="visitexplain">{{ item.explain }}</pre>
					<div class="checkbox-frame">
						<v-divider class="mt-2"></v-divider>
						<v-layout wrap>
							<v-flex xs12 v-for="(detail, i) in item.category_details" :key="i">
								<checkBoxIcon :check="item.items[i]" :color="$store.state.PointColor7" style="border-bottom:1px;" class="mr-3" />
							</v-flex>
						</v-layout>
					</div>
				</div>
				<div v-else-if="item.type == 12" class="item-style">
					<p class="surveyName">{{ i + 2 }}. {{ item.contents }}</p>
					<pre class="visitexplain">{{ item.explain }}</pre>
					<v-divider class="mt-2"></v-divider>
					<div>
						<selectBox2
							:sel="item.items"
							:items="item.category_details.map(x => x.detailname)"
							@change="changeSelected"
							class="mt-5 mb-5"
						/>
					</div>
				</div>
				<div v-else-if="item.type == 20" :class="nowWidth > 320 ? 'item-style' : 'item-style4'">
					<p class="surveyName">{{ i + 2 }}. {{ item.contents }}</p>
					<pre class="visitexplain">{{ item.explain }}</pre>
					<v-divider class="mt-2"></v-divider>
					<txtField v-model="item.items.value" :txtField="item.items" class="mt-5" />
				</div>
				<!-- <div v-else-if="item.type == 21" class="fileMargin"> -->
				<div v-else-if="item.type == 21" :class="nowWidth > 320 ? 'item-style' : 'item-style4'" style="height: max-content;">
					<!-- :class="$route.path.indexOf('COUNSELORPAGE') > -1 ? ['uploadMargin', 'minmax-width320'] : ['uploadMargin']" -->
					<p class="surveyName">{{ i + 2 }}. {{ item.contents }}</p>
					<pre class="visitexplain">{{ item.explain }}</pre>
					<!-- <v-btn color="#FDC85A">파일추가</v-btn> -->
					<v-divider class="mt-2 mb-3"></v-divider>
					<upload-images
						v-if="$route.path.indexOf('COUNSELORPAGE') > -1"
						:uploadMsg="uploadImagesOptions.uploadMsg"
						clearAll=" "
						class="mb-2"
						@changed="handleImages"
						:class="nowWidth > 600 ? ['imgUploads2', 'direction-row'] : ['imgUploads2', 'direction-column']"
					/>
					<upload-images
						v-else
						:uploadMsg="uploadImagesOptions.uploadMsg"
						clearAll=" "
						class="mb-2"
						@changed="handleImages"
						:class="nowWidth > 600 ? ['imgUploads', 'direction-row'] : ['imgUploads', 'direction-column']"
					/>
					<input id="uploadBtn" style="display:none;" type="file" accept="image/*" @change="uploadMultiple($event)" multiple />
					<div v-for="(a, idx) in $store.state.reserveusersData.fileUpload" :key="idx">
						<span class="visitexplain" @click="imgdialog(idx)">
							{{ a.name }}
						</span>
						<v-icon v-if="$route.path.split('/')[1] !== 'COUNSELORPAGE'" @click="userimgdelete(idx)">mdi-close</v-icon>
					</div>
				</div>
			</div>

			<div v-if="item.type == 30" :class="nowWidth > 320 ? 'item-style2' : 'item-style4'">
				<!-- <p class="dateGuideDay">방문하시고자 하는 날짜를 선택해 주시기 바랍니다</p> -->
				<div>
					<p class="surveyName">날짜선택 <span class="required-red-dot">*</span></p>
					<v-divider></v-divider>
					{{ item.items }}
					<v-date-picker
						locale="ko-kr"
						v-model="picker.date"
						no-title
						:events="datePickerEvents"
						:allowed-dates="allowedDates"
						@change="changePicker"
						class="dragPicker mb-2"
						:style="`--background-color:${$store.state.PointColor7}`"
						:color="$store.state.PointColor7"
					>
					</v-date-picker>
					<v-layout align-center class="squareLayout">
						<div class="dateSquare mr-1" :style="`background-color:${$store.state.PointColor7}`"></div>
						선택
						<div class="dateSquare ml-4 mr-1" style="background-color:#F2F2F2; border:2px #DEDEDE solid"></div>
						불가
						<div class="dateSquare ml-4 mr-1" style="background-color:#D8DADC; border:2px #A3A3A3 solid"></div>
						가능
					</v-layout>
					<!-- <v-img src="/image/calenderImg.jpg"></v-img>? -->
					<v-divider></v-divider>
					<p class="selectResVisit mt-5">
						선택하신 날짜는
						<span v-if="picker.date !== ''">{{ picker.date | moment('YYYY년 MM월 DD일') }} </span>
						입니다.
					</p>
					<!-- <p class="selectedRes mb-5">방문하시고자 하는 시간을 선택해주시기 바랍니다</p> -->
				</div>
			</div>

			<div v-else-if="item.type == 31" class="item-style" v-show="picker.date !== ''">
				<p class="surveyName">시간선택 <span class="required-red-dot">*</span></p>
				<v-divider></v-divider>
				<v-layout flex-wrap style="max-width:320px;">
					<v-flex xs3 v-for="(time, i) in timeData" :key="i">
						<v-btn
							width="100%"
							height="50px"
							:disabled="time.disable"
							elevation="0"
							:color="time.active || $store.state.selectedTime === time.time ? `grey lighten-2` : 'white'"
							@click="clickTime(time)"
							class="rounded-0 surveyName"
						>
							<span style="line-height: 120%;">
								{{ time.time }} <br /><span v-if="false" class="smallCheck">{{ time.countCheck }}</span></span
							>
						</v-btn>
					</v-flex>
				</v-layout>
				<v-divider></v-divider>

				<div v-if="reservedaysData.splitMinute !== '60' && $store.state.selectedTime">
					<div style="text-align: center;" class="my-3">
						<v-icon size="30">mdi-chevron-down</v-icon>
					</div>
					<v-layout flex-wrap style="max-width:320px;">
						<v-radio-group v-model="timeRadio" row style="width:320px;">
							<v-flex xs6 v-for="(time, i) in timeSlice" :key="i" class="mb-2">
								<v-radio
									:color="$store.state.PointColor7"
									:value="time.time"
									:dark="time.disable"
									:disabled="time.disable"
									:label="time.countCheck ? `${time.time}` : `${time.time}`"
									@click="clickDetailTime(timeRadio)"
								>
									<!-- :label="time.countCheck ? `${time.time} ${time.countCheck}` : `${time.time}`" -->
								</v-radio>
							</v-flex>
						</v-radio-group>
					</v-layout>
				</div>
				<p class="selectResVisit mt-5">
					선택하신 날짜는
					<span v-if="picker.date !== ''">{{ picker.date | moment('YYYY년 MM월 DD일') }}</span>
					입니다.<br />

					선택하신 시간은
					<span v-if="picker.date !== ''"> {{ $store.state.selectedTimeDetail }} </span>
					입니다.<br />

					위의 시간으로 예약하시겠습니까?
				</p>
			</div>
		</v-layout>

		<alertModal2 :setdialog="alertModal" />
		<v-dialog v-model="imgfile.dialog">
			<v-card class="imageDialog">
				<v-card-title class="title" :style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}`">
					<h2>
						{{ imgfile.img.name }}
					</h2>
					<v-spacer />
					<v-icon @click="imgfile.dialog = false" :color="`${$store.state.PointColor8}`" class="title-icon" large>mdi-close</v-icon>
				</v-card-title>
				<div class="dialog-content">
					<v-img :src="$store.state.backServer + imgfile.img.url"></v-img>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import times from '../../utils/times.js'
import uploadImages from 'vue-upload-drop-images' // 파일 업로드 패키지
import { checkBoxIcon, txtField, selectBox2, selectBox, alertModal2 } from '@/components/index.js'
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'
export default {
	components: {
		checkBoxIcon,
		txtField,
		selectBox2,
		uploadImages,
		alertModal2,
		selectBox,
	},
	props: {
		reservedaysData: Object,
		step1: Boolean,
	},

	data() {
		return {
			Companion: [
				{
					detailname: '1명(본인)',
					detailcode: 1,
				},
				{
					detailname: '2명(본인포함)',
					detailcode: 2,
				},
				{
					detailname: '3명(본인포함)',
					detailcode: 3,
				},
				{
					detailname: '4명(본인포함)',
					detailcode: 4,
				},
				{
					detailname: '5명(본인포함)',
					detailcode: 5,
				},
			],
			f0wds1810_txtFiled: {
				value: '',
				maxlength: '200',
				outlined: true,
				autofocus: false,
				hideDetail: true,
				errorMessage: '',
				placeholder: '00년 00월 00일',
			},
			doneBtn: {
				class: 'saveBtn',
				block: true,
			},
			alertModal: {
				text: '',
				dialog: false,
			},
			uploadImagesOptions: {
				max: 3,
				uploadMsg: '이미지를 등록해주세요.',
				classOn: false,
			}, // 이미지 업로드 옵션
			viewportList: [],
			// viewport 옵션들
			radioSelected: '',
			txt: {
				value: '',
				maxlength: '255',
				outlined: true,
				autofocus: false,
				hideDetail: false,
				errorMessage: '',
			},
			timeData: [], // 시간 데이터 관련
			timeRadio: '',
			selOptions: { label: '', value: '', errorMessage: '', hideDetail: true, outlined: true }, // viewport 셀렉트 박스 옵션
			datetimeArray: [],
			screenWidth: '',

			imgfile: {
				dialog: false,
				img: [],
			},
			// $store.state.nowRadioValue: [], // 현재 라디오버튼 value 임시 저장
			allowDates: [],
			timeSlice: { value: '', items: [], errorMessage: '', hideDetail: true, outlined: true, valIndex: '' }, // viewport 셀렉트 박스 옵션
		}
	},
	created() {
		this.timeSet()
		if (this.$route.name === 'reserveday' || this.$route.name === 'visitUploadModal' || this.$route.name === 'changeReserve')
			this.rangeMaxcount()
		// this.$store.state.searchsel_city2.items = location1['서울특별시'].sort()
		// this.$store.state.searchsel_city3.items = location2['서울특별시']['강남구'].sort()
		// setTimeout(() => {
		// 	this.checkboxIcon()
		// }, 500)
		this.screenWidth = window.innerWidth
	},
	computed: {
		picker: {
			get() {
				return this.$store.state.picker
			},
			set(value) {
				this.$store.commit('picker', value)
			},
		},
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		loc_firstSelect(val) {
			this.$store.state.searchsel_city2.items = location1[val].sort()
			this.$store.state.searchsel_city2.value = ''
			this.$store.state.searchsel_city3.value = ''
		},
		loc_twoSelect(val) {
			this.$store.state.searchsel_city3.value = ''
			this.$store.state.searchsel_city3.items = location2[this.$store.state.searchsel_city1.value][val].sort()
		},
		datePickerEvents(date) {
			if (
				new Date(date).toISOString().substring(0, 10) >= new Date(this.$store.state.startDate).toISOString().substring(0, 10) &&
				new Date(date).toISOString().substring(0, 10) <= new Date(this.$store.state.endDate).toISOString().substring(0, 10)
			) {
				return ['#BEC7C7']
			} else {
				return false
			}
		},
		setRadioValue(idx) {
			let findetc

			findetc = this.$store.state.reservedayInputBox.categories[idx].category_details.findIndex(e => e.detailname === '기타')

			let categoryDetail = this.$store.state.reservedayInputBox.categories[idx].category_details
			let value = this.$store.state.reservedayInputBox.categories[idx].value
			if (categoryDetail[findetc]) {
				let etcIndex = this.$store.state.nowRadioValue.indexOf(categoryDetail[findetc].detailcode)
				if (value === categoryDetail[findetc].detailcode) {
					if (etcIndex === -1) {
						this.$store.state.nowRadioValue.push(categoryDetail[findetc].detailcode)
					}
				} else {
					if (etcIndex !== -1) {
						this.$store.state.nowRadioValue.splice(etcIndex, 1)
					}
				}
			}
		},
		imgdialog(idx) {
			this.imgfile.dialog = true
			this.imgfile.img = this.$store.state.reserveusersData.fileUpload[idx]
		},
		userimgdelete(idx) {
			this.$store.state.reserveusersData.fileUpload.splice(idx, 1)
		},
		handleImages(files) {
			let fileArr = files
			let filemax
			if (!fileArr) {
				filemax = this.$store.state.reserveusersData.fileUpload.length
			} else if (!this.$store.state.reserveusersData.fileUpload) {
				filemax = fileArr.length
			} else {
				filemax = fileArr.length + this.$store.state.reserveusersData.fileUpload.length
			}

			if (filemax === 3) {
				setTimeout(() => {
					document.querySelector('.plus').style.display = 'none'
				}, 500)
			}
			if (filemax > 3) {
				fileArr.pop()
				this.alertModal.text = '이미지는 3개까지만 등록 가능합니다.'
				this.alertModal.dialog = true
			}
			this.$store.commit('filesData', fileArr)
		},
		changePicker(val) {
			this.$store.state.selectedTime = ''
			this.timeData.forEach(element => {
				element.active = false
			})
			this.changeTimeSet(val)
		},
		rangeMaxcount() {
			let data
			data = {
				sdate: this.$moment(this.reservedaysData.sdate).format('YYYY-MM-DD'),
				edate: this.$moment(this.reservedaysData.edate).format('YYYY-MM-DD'),
				status: 1,
				code: this.$route.params.code,
			}

			this.$store
				.dispatch('reserveusersRangeCount', data)
				.then(res => {
					let reseveIndex = res.data.reserveusersRangeCount.count.items.findIndex(e => e.List === this.reservedaysData.title)
					let reseveCount = res.data.reserveusersRangeCount.count.items[reseveIndex]

					//하루 가능 예약 수
					let nowCount = []

					this.reservedaysData.nodaySetting.forEach(e => {
						let count = 0
						e.times.forEach(item => {
							count = count + Number(item.maxCount)
						})
						let dayCount = { date: e.date, count: count }
						nowCount.push(dayCount)
					})
					nowCount.forEach(e => {
						const beforeCheck = this.$moment(
							this.$moment()
								.subtract(1, 'days')
								.format('YYYY-MM-DD'),
						).isBefore(e.date)
						if (reseveCount[this.$moment(e.date).format('YY-MM-DD')] < e.count && beforeCheck) {
							this.allowDates.push(e.date)
						}
					})
				})
				.catch(() => {})
		},
		allowedDates(val) {
			setTimeout(() => {
				const events = document.getElementsByClassName('v-date-picker-table__events')
				events.forEach(element => {
					element.parentElement.style.backgroundColor = '#F2F2F2'
				})
			}, 300)
			return this.allowDates.indexOf(val) !== -1
		}, // date-picker 선택 가능날짜 세팅
		timeSet() {
			if (this.$store.state.timeRange !== '' && this.$store.state.timeRange !== null) {
				let startTime = Number(this.$store.state.timeRange.split(',')[0].split(':')[0])
				let endTime = Number(this.$store.state.timeRange.split(',')[1].split(':')[0])
				// var sdate = new Date(this.$store.state.startDate)
				// var edate = new Date(this.$store.state.endDate)
				// var days = Math.ceil((edate.getTime() - sdate.getTime()) / (1000 * 3600 * 24)) + 1

				for (startTime; startTime < endTime; startTime++) {
					this.timeData.push({ time: `${String(startTime)}:00`, active: false, disable: false, countCheck: '' })
					//기존 방문예약 30분 단위 추가
					// if (this.reservedaysData.splitMinute === null && days !== this.reservedaysData.nodaySetting.length) {
					// 	this.timeData.push({ time: `${String(startTime)}:30`, active: false, disable: false, countCheck: '' })
					// }
				}
				if (!this.reservedaysData.splitMinute) {
					this.timeData.push({ time: `${String(endTime)}:00`, active: false, disable: false, countCheck: '' })
				}
				// let endTimeMin = Number(this.$store.state.timeRange.split(',')[1].split(':')[1])
				// if (endTimeMin === 30) {
				// 	this.timeData.push({ time: `${String(endTime)}:30`, active: false, disable: false })
				// }
				this.timeData.forEach(obj => {
					if (obj.time === '8:00') {
						obj.time = '08:00'
					} else if (obj.time === '8:30') {
						obj.time = '08:30'
					} else if (obj.time === '9:00') {
						obj.time = '09:00'
					} else if (obj.time === '9:30') {
						obj.time = '09:30'
					}
				})
				this.$store.state.timeDataCopy = this.timeData
			} else {
				times.forEach(element => {
					this.timeData.push({
						time: element,
						active: false,
					})
				})
			}
		},
		clickTime(item) {
			if (this.reservedaysData.splitMinute) {
				setTimeout(() => {
					this.$store.state.selectedTime = item.time
				}, 500)
			} else {
				this.$store.state.selectedTime = item.time
			}
			this.$store.state.selectedTimeDetail = ''

			if (this.reservedaysData.splitMinute === '60') {
				this.$store.state.selectedTimeDetail = item.time
			}

			///시간 클릭
			this.timeData.forEach(element => {
				element.active = false
			})
			item.active = true

			if (this.reservedaysData.splitMinute !== '') {
				this.sliceTime(item)
			}
		},
		sliceTime(time) {
			const date = String(`${this.$store.state.picker.date}T00:00:00.000Z`)
			const data = {
				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				date: date,
			}
			this.$store.state.loading = true
			this.$store
				.dispatch('reservedayMaxCount2', data)
				.then(res => {
					this.$store.state.loading = false
					let dateIndex = this.reservedaysData.nodaySetting.findIndex(e => e.date === this.$store.state.picker.date)
					let selcetNodayset = this.reservedaysData.nodaySetting[dateIndex]
					let resCount = res.data.reservedayMaxCount2.count

					let filterd = selcetNodayset.times.filter(e => {
						return e.clock.split(':')[0] === time.time.split(':')[0]
					})
					let maxcountitems = []
					filterd.forEach(e => {
						let clock
						if (e.clock.split(':')[0] === '08' || e.clock.split(':')[0] === '09') {
							clock = e.clock.substr(1)
						} else {
							clock = e.clock
						}
						let resCountIndex = resCount.findIndex(obj => Object.keys(obj)[0] === clock)
						if (e.maxCount !== 0) {
							if (resCount[resCountIndex][clock] < e.maxCount) {
								maxcountitems.push({
									time: e.clock,
									disable: false,
									countCheck: `(${resCount[resCountIndex][clock]}/${e.maxCount})`,
								})
							} else {
								maxcountitems.push({
									time: e.clock,
									disable: true,
									countCheck: `(${resCount[resCountIndex][clock]}/${e.maxCount})`,
								})
							}
						}
					})
					this.timeSlice = maxcountitems
					this.$store.state.loading = false
				})
				.catch(() => {
					this.$store.state.loading = false
				})

			// this.sliceItmeDelete()
			// if (this.reservedaysData.splitMinute) {
			// 	// let endTimeMin = Number(time.time.split(':')[1])
			// 	// let endTimeHour = time.time.split(':')[0]

			// 	let timeSet = this.reservedaysData.splitMinute
			// 	let numberofTime = 60 / timeSet
			// 	for (let index = 0; index < numberofTime; index++) {
			// 		let minute = String(timeSet * index)
			// 		if (minute.length === 1) {
			// 			minute = '0' + minute
			// 		}
			// 		// maxcountitems.push({
			// 		// 	time: endTimeHour + ':' + minute,
			// 		// 	active: false,
			// 		// })
			// 	}

			// 	// this.timeSlice = maxcountitems

			// 	// if (time.time === this.timeData[this.timeData.length - 1].time) {
			// 	// 	this.timeSlice.items = [time.time]
			// 	// }
			// 	this.sliceItmeDelete()
			// }
		},
		slicedSelect() {
			this.$store.state.selectedTime = this.timeSlice.value
			this.$store.state.selectedTimeDetail = this.timeSlice.value
		},
		sliceItmeDelete() {
			// 시간 단위 selectBox  item 제거
			const date = String(`${this.$store.state.picker.date}T00:00:00.000Z`)
			const data = {
				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				date: date,
			}
			this.$store.state.loading = true
			this.$store
				.dispatch('reservedayMaxCount2', data)
				.then(res => {
					this.$store.state.loading = false

					let dateIndex = this.reservedaysData.nodaySetting.findIndex(e => e.date === this.$store.state.picker.date)
					let dateMaxcount = this.reservedaysData.nodaySetting[dateIndex].maxcount

					let eachMaxcount = Math.floor(dateMaxcount / (60 / this.reservedaysData.splitMinute))
					// max count 체크해서 아이템 제거
					res.data.reservedayMaxCount2.count.forEach(e => {
						let time = Object.keys(e)[0]
						let add
						if (time.length === 4) {
							add = '0' + time
						} else {
							add = time
						}
						let disableIndex = this.timeSlice.findIndex(item => item.time === add)
						if (e[time] >= eachMaxcount) {
							// let sliceIndex = this.timeSlice.items.indexOf(time)
							if (disableIndex !== -1) {
								this.timeSlice[disableIndex].disable = true
								this.timeSlice[disableIndex].countCheck = `(${e[time]}/${eachMaxcount})`
							}
						} else {
							if (disableIndex !== -1) {
								this.timeSlice[disableIndex].countCheck = `(${e[time]}/${eachMaxcount})`
							}
						}
					})
					// 제외시간 체크해서 아이템 제거
					let dateNotime = this.reservedaysData.nodaySetting[dateIndex].noTime
					if (dateNotime.length !== 0) {
						dateNotime.forEach(notime => {
							// let sliceIndex = this.timeSlice.items.indexOf(notime)
							// if (sliceIndex !== -1) {
							// 	this.timeSlice.items.splice(sliceIndex, 1)
							// }
							let disableIndex = this.timeSlice.findIndex(item => item.time === notime)
							if (disableIndex !== -1) {
								this.timeSlice.splice(disableIndex, 1)
							}
						})
					}
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		clickDetailTime(time) {
			this.$store.state.selectedTimeDetail = time
			this.$store.state.selectedTime = time
			// this.directDone.class = 'resnextBtn'
		},
		changeSelected(value) {
			let valueArray = this.$store.state.selectedValues
			let foundIndex = valueArray.findIndex(obj => {
				return obj.code === value.code
			})
			if (foundIndex === -1) {
				valueArray.push(value)
			} else {
				valueArray.splice(foundIndex)
				valueArray.push(value)
			}
			this.$store.commit('selectedValues', valueArray)
		},
		changeTimeSet(selectDay) {
			// maxcount 체크해서 시간 disable
			const date = String(`${this.$store.state.picker.date}T00:00:00.000Z`)
			const data = {
				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				date: date,
			}
			this.$store
				.dispatch('reservedayMaxCount2', data)
				.then(res => {
					let nodayIndex = this.reservedaysData.nodaySetting.findIndex(e => e.date === selectDay)
					let nodaySet = this.reservedaysData.nodaySetting[nodayIndex]
					let resCount = res.data.reservedayMaxCount2.count
					let countByHour = {}
					resCount.forEach(e => {
						let countHour = Object.keys(e)[0]
						if (countHour.length === 4) {
							countHour = '0' + countHour
						}
						let hour = countHour.split(':')[0] + ':00'
						if (countByHour[hour] === undefined) {
							countByHour[hour] = { nowcount: 0, maxcount: 0, full: true }
						}
						let timeIndex = nodaySet.times.findIndex(obj => obj.clock === countHour)

						if (timeIndex !== -1) {
							countByHour[hour].maxcount = countByHour[hour].maxcount + Number(nodaySet.times[timeIndex].maxCount)
							countByHour[hour].nowcount = countByHour[hour].nowcount + Number(e[Object.keys(e)[0]])

							if (e[Object.keys(e)[0]] < nodaySet.times[timeIndex].maxCount) {
								countByHour[hour].full = false
							}
						}
					})
					this.timeData.forEach(e => {
						e.disable = countByHour[e.time].full
						e.countCheck = `(${countByHour[e.time].nowcount}/${countByHour[e.time].maxcount})`
					})
				})
				.catch(() => {})
		},
		maxcountCheck2() {
			// 시간 안쪼갰을 때 maxcount check
			const date = String(`${this.$store.state.picker.date}T00:00:00.000Z`)
			const data = {
				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				date: date,
			}
			this.$store.state.loading = true
			this.$store
				.dispatch('reservedayMaxCount2', data)
				.then(res => {
					this.$store.state.loading = false
					let dateIndex = this.reservedaysData.nodaySetting.findIndex(e => e.date === this.$store.state.picker.date)
					let dateMaxcount = this.reservedaysData.nodaySetting[dateIndex].maxcount

					let timeMaxcount = {}
					res.data.reservedayMaxCount2.count.forEach(e => {
						let time = Object.keys(e)[0]
						// if (time.length === 4) {
						// 	time = '0' + time
						// }
						timeMaxcount[time.split(':')[0] + ':00'] = 0
					})

					res.data.reservedayMaxCount2.count.forEach(e => {
						let time = Object.keys(e)[0]
						// if (time.length === 4) {
						// 	time = '0' + time
						// }
						timeMaxcount[time.split(':')[0] + ':00'] = timeMaxcount[time.split(':')[0] + ':00'] + e[time]
					})

					let time = Object.keys(timeMaxcount)
					time.forEach(e => {
						let added

						if (e.length === 4) {
							added = '0' + e
						} else {
							added = e
						}
						let timeIndex = this.timeData.findIndex(time => time.time === added)

						if (Number(timeMaxcount[e]) >= Number(dateMaxcount)) {
							this.timeData[timeIndex].disable = true
						} else {
							this.timeData[timeIndex].disable = false
						}

						this.timeData[timeIndex].countCheck = `(${Number(timeMaxcount[e])}/${dateMaxcount})`
					})

					// 제외시간 체크해서 disable
					let dateNotime = this.reservedaysData.nodaySetting[dateIndex].noTime

					if (dateNotime.length !== 0) {
						dateNotime.forEach(notime => {
							let timeIndex = this.timeData.findIndex(time => time.time === notime)
							this.timeData[timeIndex].disable = true
						})
					}

					// 	let eachMaxcount = Math.floor(dateMaxcount / (60 / this.reservedaysData.splitMinute))
					// 	// max count 체크해서 아이템 제거
					// 	res.data.reservedayMaxCount2.count.forEach(e => {
					// 		let time = Object.keys(e)[0]
					// 		if (e[time] >= eachMaxcount) {
					// 			let sliceIndex = this.timeSlice.items.indexOf(time)
					// 			if (sliceIndex !== -1) {
					// 				this.timeSlice.items.splice(sliceIndex, 1)
					// 			}
					// 		}
					// 	})
					// 	// 제외시간 체크해서 아이템 제거
					// 	let dateNotime = this.reservedaysData.nodaySetting[dateIndex].noTime
					// 	if (dateNotime.length !== 0) {
					// 		dateNotime.forEach(notime => {
					// 			let sliceIndex = this.timeSlice.items.indexOf(notime)
					// 			if (sliceIndex !== -1) {
					// 				this.timeSlice.items.splice(sliceIndex, 1)
					// 			}
					// 		})
					// 	}
					this.$store.state.loading = false
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
	},
}
</script>

<style lang="scss">
.f0wdsl81o-textFiled {
	.v-input__control {
		.v-input__slot {
			height: 30px !important;
			min-height: 30px !important;
		}
	}
}
.v-list .primary--text {
	color: red !important;
}
.v-date-picker-table__events {
	display: none;
}
.dragPicker .v-btn.v-btn--active {
	background-color: var(--background-color) !important;
}
.explain {
	margin-top: -15px;
	font-size: 12px;
	color: #003293;
}
.imgUploads {
	min-width: 250px;
	display: flex !important;
	justify-content: center !important;
	align-items: center;
	flex-wrap: nowrap !important;
	flex-direction: row !important;
	padding: 10px 50px 10px 50px;
	/* padding-top: 20px;
	padding-right: 50px;
	padding-bottom: 5px; */
	height: 70% !important;
	overflow-y: hidden;
}
.imgUploads2 {
	min-width: 250px;
	display: flex !important;
	justify-content: center !important;
	align-items: center;
	flex-wrap: nowrap !important;
	flex-direction: row !important;
	padding: 10px 50px 10px 50px;
	/* padding-top: 20px;
	padding-right: 50px;
	padding-bottom: 5px; */
	height: 60% !important;
}
.viewport-item {
	.v-date-picker-header__value {
		pointer-events: none;
	}
	.v-select__slot {
		height: 27px !important;
	}
	.v-radio {
		align-items: start;
	}
	.v-input__slot {
		align-items: start;
	}
	.v-input__slot {
		align-items: start !important;
		.v-label {
			font-size: 15px;
		}
		.v-icon {
			font-size: 20px;
		}
	}

	.focusColorButton {
		.primary--text {
			&.v-input,
			&.v-icon {
				color: #fade0d !important;
				caret-color: #fade0d !important;
			}
		}
	}
	.surveyName {
		font-size: 15px;
		font-weight: 500;
		margin-bottom: 0px !important;
	}
}

.viewport-item-counselor {
	.v-date-picker-header__value {
		pointer-events: none;
	}
	.v-radio {
		align-items: start;
	}
	.v-input__slot {
		align-items: start;
	}
	.v-input__slot {
		align-items: start !important;
		.v-label {
			font-size: 15px;
		}
		.v-icon {
			font-size: 20px;
		}
	}
	.focusColor {
		.primary--text {
			color: black !important;
			caret-color: black !important;
			&.v-input,
			&.v-select,
			&.v-icon {
				color: black !important;
				caret-color: black !important;
			}
			.v-input .v-select {
				color: black !important;
				caret-color: black !important;
			}

			// &.v-tabs-bar {
			// 	color: black !important;
			// 	caret-color: black !important;
			// 	.v-tab--active {
			// 		color: black !important;

			// 		& > .icon {
			// 			color: black !important;
			// 		}
			// 	}
			// }
		}
	}

	.focusColorButton {
		.primary--text {
			&.v-input,
			&.v-icon {
				color: #fade0d !important;
				caret-color: #fade0d !important;
			}
		}
	}
	.surveyName {
		font-size: 15px;
		font-weight: 500;
		margin-bottom: 0px !important;
	}
}
.direction-column {
	.imgsPreview {
		display: flex !important;
		justify-content: center;
		flex-direction: column !important;
	}
}
.direction-row {
	.imgsPreview {
		display: flex !important;
		align-items: center !important;
		flex-direction: row !important;
	}
}
.fileMargin {
	margin-bottom: 100px;
}
.selectResVisit {
	font-size: 14px;
	font-weight: 500;
	margin-bottom: 0px !important;
	span {
		color: #0cb3d6;
	}
}
.visitexplain {
	font-size: 13px;
	color: #a2a2a2;
	white-space: break-spaces;
}
.squareLayout {
	font-size: 15px;
	font-weight: bold;
	color: #636363;
	padding: 10px 0px 10px 30px;
}
.dateSquare {
	width: 17px;
	height: 17px;
}
</style>
<style lang="scss" scoped>
.visitexplain {
	font-size: 13px;
	color: #6e6e6e;
	white-space: break-spaces;
}
.viewport-item {
	.item-style {
		width: 320px;
	}
	.item-style2 {
		// min-width: 275px;
		width: 320px;
	}
	.item-style3 {
		// min-width: 275px;
		width: 300px;
	}
	.item-style4 {
		// min-width: 275px;
		width: 300px;
	}
	padding: 15px 8px;
	// border-bottom: 0.5px dashed #e0e0e0;
}

.viewport-item-counselor {
	width: 100%;
	// .item-style {
	// 	// width: 320px;
	// }
	// .item-style2 {
	// 	// min-width: 275px;
	// 	// width: 320px;
	// }
	// .item-style3 {
	// 	// min-width: 275px;
	// 	// width: 300px;
	// }
	// .item-style4 {
	// 	// min-width: 275px;
	// 	// width: 270px;
	// }
	padding: 40px 0px 0px;
	// border-bottom: 0.5px dashed #e0e0e0;
}
.required-red-dot {
	color: #ff5252;
}
// .uploadMargin {
// 	margin-bottom: 140px;
// }
.minmax-width320 {
	min-width: 320px;
	max-width: 320px;
}
.smallCheck {
	background-color: #e8e8e8;
	padding: 2px 4px !important;
	font-size: 11px;
	border-radius: 5px;
}
.imageDialog {
	.title {
		height: 60px;
		display: flex;
		align-items: center;
		padding: 0 25px;
	}
	.dialog-content {
		padding: 40px;
	}
	.bottom {
		display: flex;
		margin-top: 20px;
	}
}
</style>
